import React from "react"

export default function Checked() {
   return (
      <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
         <g clipPath="url(#clip0_3_11924)">
            <path d="M9.84781 16.6933L5.67781 12.5233L4.25781 13.9333L9.84781 19.5233L21.8478 7.52328L20.4378 6.11328L9.84781 16.6933Z" fill="#705ec9" />
         </g>
         <defs>
            <clipPath id="clip0_3_11924">
               <rect width="24" height="24" fill="white" transform="translate(0.847656 0.523438)" />
            </clipPath>
         </defs>
      </svg>
   )
}